import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardContainer, LightButton } from "best-common-react";
import AdditionalOptions from "./AdditionalOptions";
import { CompConstants } from "../../constants/CompConstants";
import { ReportConstants } from "../../constants/ReportConstants";
import NewTimeFrameModal from "./NewTimeFrameModal";
import TimeFrames from "./TimeFrames";

class OneOnOneComp extends React.Component {
  render() {
    let { trackingHelper } = this.props.rootStore;
    return (
      <React.Fragment>
        <NewTimeFrameModal tab={CompConstants.TABS.ONE_ON_ONE} />
        <CardContainer>
          <CardContainer.Body>
            <div className="container-fluid">
              <div className="row mx-0">
                <TimeFrames tab={CompConstants.TABS.ONE_ON_ONE} />
                <AdditionalOptions tab={CompConstants.TABS.ONE_ON_ONE} />
              </div>
            </div>
          </CardContainer.Body>
          <CardContainer.Footer>
            <div className="header-item-row">
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_1ON1,
                    "Run Standard One-on-One Report Click"
                  );
                }}
              >
                Run Standard One-on-One Report
              </LightButton>
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_1ON1AWARDS,
                    "Run One-on-One Report With Awards Click"
                  );
                }}
              >
                Run One-on-One Report With Awards
              </LightButton>
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_MULTIPLAYER1ON1,
                    "Run Multiple One-on-One Report Click"
                  );
                }}
              >
                Run Multiple One-on-One Report
              </LightButton>
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_CAREER1ON1,
                    "Run Career One-on-One Report Click"
                  );
                }}
              >
                Run Career One-on-One Report
              </LightButton>
            </div>
          </CardContainer.Footer>
        </CardContainer>
      </React.Fragment>
    );
  }
}

OneOnOneComp.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(OneOnOneComp));
